import { BatchOperationsShortcut } from './batch-operations-shortcut';
import { DataCompletenessBadge } from './data-completeness-badge';
import { EuLogos } from './eu-logos';
import { LanguageSwitcher } from './language-switcher';
import { SettingsShortcut } from './settings-shortcut';

interface SidebarBottomSectionProps {
  isCollapsed: boolean;
}

/**
 * Sidebar Bottom Section
 * Contains EU logos, batch ops, and language switcher
 * Adapts layout based on collapsed state
 */
export function SidebarBottomSection({
  isCollapsed,
}: SidebarBottomSectionProps) {
  return (
    <div className="border-t border-gray-200 pt-4 dark:border-gray-700">
      {/* EU Logos - only show when expanded */}
      {!isCollapsed && <EuLogos />}

      {/* Utility row: Batch Operations + Language Switcher */}
      {!isCollapsed && (
        <div className="flex items-center justify-center gap-2 px-4">
          <SettingsShortcut isCollapsed={false} />
          <BatchOperationsShortcut isCollapsed={false} />
          <DataCompletenessBadge isCollapsed={false} />
          <LanguageSwitcher isCollapsed={false} />
        </div>
      )}

      {/* Collapsed: vertical stack */}
      {isCollapsed && (
        <div className="flex flex-col items-center gap-4">
          <SettingsShortcut isCollapsed={true} />
          <BatchOperationsShortcut isCollapsed={true} />
          <DataCompletenessBadge isCollapsed={true} />
          <LanguageSwitcher isCollapsed={true} placement="bottomRight" />
        </div>
      )}
    </div>
  );
}
